import React, { useContext, useState, useEffect } from "react";
import { Modal, Box, TextField, Button, Typography, FormControl, Table, TableBody, TableCell, TableContainer, TableRow, Paper, IconButton, Grid, TableHead, Checkbox } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { updateSLTPOrders, deleteSLTPOrders, modifyPositionSLTP } from "../../../api/request/dashboard/dashboard";
import toast from 'react-hot-toast';
import { useDispatch } from "react-redux";
import { editSLTPOrder, deleteSLTPOrder, addSLTPOrder } from "../../../store/Slices/orderPositionSlice";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { DeleteOutline, EditOutlined } from '@mui/icons-material'
import AddEditModal from "./AddEditModal";
// import AddEditModal from "./AddEditModal";


const initForm = { amount: "", st: "", tp: "" }
const EditPositionModal = ({ open, handleClose, editSLTP }) => {
    const { darkMode } = useContext(ThemeContext);
    const [selectedSLTP, setSelectedSLTP] = useState(null);
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [formData, setFormData] = useState(initForm);
    const dispatch = useDispatch()
    console.log(editSLTP)
    useEffect(() => {
        setFormData({
            amount: selectedSLTP?.amount || "",
            st: selectedSLTP?.stopLoss || "",
            tp: selectedSLTP?.takeProfit || ""
        });
        // }
    }, [selectedSLTP]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEdit = async () => {
        if (!selectedSLTP) return toast.error("No order selected");

        const updatedOrder = {
            id: selectedSLTP.id,
            amount: formData.amount,
            stopLoss: formData.st,
            takeProfit: formData.tp,
            accountId: selectedSLTP.accountId
        };

        try {
            const response = await updateSLTPOrders(updatedOrder);
            dispatch(editSLTPOrder(response));
            toast.success("SLTP updated successfully");
            // setIsOpenEdit(false)
            handleClose();
        } catch (error) {
            toast.error("Failed to update order");
        }
    };

    const handlePlaceOrder = async () => {
        if (!editSLTP) return toast.error("No order selected");

        const selectedOrder = editSLTP[0]
        const newOrder = {
            accountId: selectedOrder.accountId,
            positionId: selectedOrder.positionId,
            amount: Number(formData.amount),
            stopLoss: Number(formData.st),
            takeProfit: Number(formData.tp)
        };

        try {
            const response = await modifyPositionSLTP(newOrder);
            dispatch(addSLTPOrder(response));
            toast.success("New SLTP order placed successfully");
            handleClose()
        } catch (error) {
            toast.error("Failed to place SLTP order");
        }
    };

    const handleDelete = async ({ accountId, id }) => {
        if (!selectedSLTP) return toast.error("No SLTP selected");

        try {
            const data = {
                accountId: selectedSLTP.accountId,
                id: selectedSLTP.id
            }
            await deleteSLTPOrders(data);
            dispatch(deleteSLTPOrder(selectedSLTP.id));
            toast.success("SLTP deleted successfully");
            // setIsOpenEdit(false)
            handleClose();
        } catch (error) {
            toast.error("Failed to delete SLTP");
        }
    };

    useEffect(() => {
        if (!isOpenEdit) {
            setisEdit(false);
        }
    }, [isOpenEdit])

    return (
        <>
            <Modal open={open} onClose={handleClose} aria-labelledby="edit-position-modal" maxWidth="sm" closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500, }, }}>
                <Fade in={open}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', }}>
                        <Box className="bg-primary" sx={{ padding: '5px', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography id="edit-position-modal" variant="body1" sx={{ color: "var(--white)" }} >Edit Position</Typography>
                            <IconButton onClick={handleClose} sx={{ color: "var(--white)" }}>
                                <CloseIcon sx={{ fontSize: 15 }} />
                            </IconButton>
                        </Box>

                        <Box sx={{ padding: 2 }} container>
                            <div className="flex justify-end">
                                <Button onClick={e => { setIsOpenEdit(true); setFormData(initForm); setisEdit(false) }} variant="outlined" size="small">
                                    Add New SLTP
                                </Button>
                            </div>

                            {editSLTP.length > 0 ? (
                                <Box sx={{ maxHeight: 200, overflowY: "auto", mb: 2 }}>
                                    <TableContainer component={Paper} sx={{ mt: 2, mb: 2, border: "1px solid #c6c6c6", borderRadius: 1 }}>
                                        <Table size="small" sx={{ minWidth: 250, borderCollapse: "collapse" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Amount</TableCell>
                                                    <TableCell align="center">Stop Loss</TableCell>
                                                    <TableCell align="center">Take Profit</TableCell>
                                                    <TableCell align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {editSLTP.map((sltp, index) => (
                                                    <TableRow key={index} hover sx={{ cursor: "pointer" }}>
                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}>{sltp.amount}</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}>{sltp.stopLoss}</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}>{sltp.takeProfit}</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: 13, color: "#da5244", width: "20%", "& .MuiSvgIcon-root": { fontSize: 17, } }} ><DeleteOutline onClick={e => handleDelete(sltp)} /> <EditOutlined onClick={e => { setSelectedSLTP(sltp); setIsOpenEdit(true); setisEdit(true); }} /> </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ) : null}
                        </Box>
                    </Box>
                </Fade>
            </Modal>
            {/* <Modal open={isOpenEdit} maxWidth="md" width="md" onClose={e => setIsOpenEdit(false)}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', }}>
                    <Box className="bg-primary" sx={{ padding: '5px', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography id="edit-position-modal" variant="body1" sx={{ color: "var(--white)" }} >{!isEdit ? "Add" : "Edit"} ProfitLoss</Typography>
                        <IconButton onClick={e => setIsOpenEdit(false)} sx={{ color: "var(--white)" }}>
                            <CloseIcon sx={{ fontSize: 15 }} />
                        </IconButton>
                    </Box>
                    <Box sx={{ padding: 2 }} container>
                        <Grid container spacing={1} mt={2} mb={2}>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <TextField focused label="Amount" name="amount" variant="outlined" value={formData.amount} onChange={handleChange} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <TextField focused label="Stop Loss" name="st" variant="outlined" value={formData.st} onChange={handleChange} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <TextField focused label="Take Profit" name="tp" variant="outlined" value={formData.tp} onChange={handleChange} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <Button onClick={isEdit ? handleEdit : handlePlaceOrder} variant="outlined" size="small" sx={{ height: '36px' }}>
                                        {isEdit ? "Edit SLTP" : "Add SLTP"}
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal> */}
            {isOpenEdit && <AddEditModal sltp={editSLTP?.[0] || {}} isOpenEdit={isOpenEdit} setIsOpenEdit={setIsOpenEdit} isEdit={isEdit} formData={formData} handleChange={handleChange} handleEdit={handleEdit} handlePlaceOrder={handlePlaceOrder} />}
        </>
    );

};

export default EditPositionModal;
